import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { AdminDispatch, AdminState } from './adminStore';
import { ClientDispatch, ClientState } from './clientStore';

// TODO Update to .withTypes() method for Toolkit v2 & React-Redux v9
export const useAppDispatch: () => AdminDispatch | ClientDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<AdminState | ClientState> = useSelector;
export const isClientState = (state: AdminState | ClientState): state is ClientState => ('addressBook' in state);